import { PrescriptionRenewal } from '../entities/PrescriptionRenewal';
import { api } from './api.service';

export interface PrescriptionRenewalPayload {
  doctorId?: string;
  description?: string;
}

export type PrescriptionRenewalResponse = PrescriptionRenewal;

export interface ListPrescriptionRenewalPayload {
  page?: number;
  quantity?: number;
}

export interface CheckPrescriptionRenewalEligibilityResponse {
  allow: boolean;
}

export enum EnumErrorPrescriptionRenewal {
  DOCTOR_NOT_FOUND = 'DOCTOR_NOT_FOUND',
  OYANA_NOT_FOUND = 'OYANA_NOT_FOUND',
  NOT_ATTENDED_BY_DOCTOR = 'NOT_ATTENDED_BY_DOCTOR',
  NO_RECENT_ATTENDANCE = 'NO_RECENT_ATTENDANCE',
  PENDING_REQUEST_ALREADY_EXISTS = 'PENDING_REQUEST_ALREADY_EXISTS',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}
export interface ErrorPrescriptionRenewalResponse {
  data: {
    errorType: EnumErrorPrescriptionRenewal;
    message: string;
  };
}

const prescriptionRenewalApi = api.injectEndpoints({
  endpoints: build => ({
    createPrescriptionRenewal: build.mutation<PrescriptionRenewalResponse, PrescriptionRenewalPayload | void>({
      query: data => ({
        url: `/portal/v1/me/prescription-renewal`,
        method: 'POST',
        body: data
      })
    }),
    listPrescriptionRenewal: build.mutation<PrescriptionRenewal[], ListPrescriptionRenewalPayload>({
      query: ({ page, quantity }) => ({
        url: `/portal/v1/me/prescription-renewal`,
        method: 'GET',
        params: { page, quantity }
      })
    }),
    checkPrescriptionRenewalEligibility: build.mutation<CheckPrescriptionRenewalEligibilityResponse, void>({
      query: () => ({
        url: `/portal/v1/me/prescription-renewal/check`,
        method: 'GET'
      })
    })
  })
});

export const {
  useCreatePrescriptionRenewalMutation,
  useListPrescriptionRenewalMutation,
  useCheckPrescriptionRenewalEligibilityMutation
} = prescriptionRenewalApi;
